

import styles from './Lines.module.css'

const Lines = ()=>{
    return(
        <div className={`flex w-full h-full absolute justify-evenly z-10 ${styles.top}`}>
            <span className='bg-white w-px h-full opacity-10'></span>
            <span className='bg-white w-px h-full opacity-10'></span>
            <span className='bg-white w-px h-full opacity-10'></span>
            <span className='bg-white w-px h-full opacity-10'></span>
        </div>
    )
}


export default Lines